import React from 'react';
import dateFormat from 'dateformat';
import convertTime from 'convert-time';

/**
 * Event Item Component
 */
const EventItem = (props) => {
	// function to truncate long event titles
	const truncateTitle = (title) => {
		if(title.length > 30) {
		    title = title.substring(0,29) + "...";
		}
		return title;
	};
	/**
     * Function to get specific image url for image of 16_9 ratio and 
     * width of 1024px, by filtering through event images array 
     * Note: this was originally in homepage.js
     * @param {object} 
     */
	const imageFilter = (event) => {
		// console.log('filter image has run, why does this show up twice on page load?');
		// Note: Originally this helper function was finding the largest image,
		// but for speed and efficiency, image width of 1024 is most desired
		// to meet sizing requirements for site performance
		const arrayFilter = {
		  ratio: '16_9',
		  width: 1024
		};

		// variable for event images array
		// *Ticketmaster events have an array of multiple sizes and ratios for main image
		let imageArray = event.images;
		// console.log(imageArray);

		// use above arrayFilter to match key/values in imageArray
		imageArray = imageArray.filter(image => {
			for (let key in arrayFilter) {
				if (image[key] !== arrayFilter[key])
					return false;
				}
			return true;
		});
		return imageArray[0].url;
	}

	let imageUrlNew = imageFilter(props.event); 

	return (
		<div className="event" data-index={props.index} data-imageurl={imageUrlNew} onClick={props.onClick}>
			<p className="event__date">{dateFormat(props.event.dates.start.localDate, 'mmm dd', true)}</p>
			<figure className="event__image-wrapper">
				<img className="event__image animated fadeIn" src={imageUrlNew} alt=""/>
			</figure>
			<div className="event__content">
				<h3 className="event__title">{truncateTitle(props.event.name)}</h3>
				<p className="event__venue-name">{props.event._embedded.venues[0].name}</p>
				{/* If localTime available, show time */}
				{props.event.dates.start.localTime ? (
			       <p className="event__time">{convertTime(props.event.dates.start.localTime)}</p>
			      ) : null}
				<button className="event__details-button" data-index={props.index} data-imageurl={imageUrlNew} onClick={props.onClick}>Details</button>
			</div>
		</div>
	)
};

export default EventItem;
